// Typed wrappers around the /v1/api-keys CRUD endpoints. Mirrors
// lib/api/agents.ts in shape so the dashboard's mutation/query call sites
// look identical regardless of the resource being managed.

import type {
  ApiKey,
  CreateApiKeyInput,
  CreateApiKeyResult,
} from '@cortex/shared';
import type { ApiClient } from '../api-client.js';

interface ApiKeyList {
  readonly keys: readonly ApiKey[];
}

export const apiKeysApi = {
  list: (api: ApiClient) => api.get<ApiKeyList>('/v1/api-keys'),
  create: (api: ApiClient, body: CreateApiKeyInput) =>
    api.post<CreateApiKeyResult>('/v1/api-keys', body),
  remove: (api: ApiClient, id: string) => api.del<undefined>(`/v1/api-keys/${id}`),
} as const;

export const API_KEYS_QUERY_KEY = ['api-keys'] as const;
